import Button from "@material-ui/core/Button";
import React from "react";

export default ({ text, customOnClick, style }) => (
  <Button
    className={style}
    size="small"
    variant="contained"
    onClick={customOnClick}
  >
    {text}
  </Button>
);
